import React, {useEffect, useState} from 'react';
import { Form, Input, DatePicker, Alert } from 'antd';
import SPSelectWithApi from "../../../../../../components/product-price/base/SPSelectWithApi";
import moment from "moment";
import dayjs from 'dayjs';
import {formatTimeRange} from "../../../../../../utils/tool";
const { TextArea } = Input;



interface IComponentProps {
    data?: any;
    enums?: any
}
const DriverPlatoon: React.FC<IComponentProps> = (props) => {
    const data = props.data;
    const { enums } = props

    const now = moment( data?.pre_return_time).add(15, 'minutes');
    const now1 =  moment(now).startOf('day');


    const disabledDate = (current: any) => {
        // 如果当前日期和时间小于当前时间，则禁用
        if (current && current < now1) return true;
        // 否则允许选择
        return false;
    };

    const disabledDateTime = (current: any) => {
        if (current?.isSame(now, 'day')) {
            if (current?.isSame(now, 'hour')) {
                return {
                    disabledHours: () => [...Array(now.hour()).keys()],
                    disabledMinutes: () => [...Array(now.minute()).keys()],
                }
            } else {
                return {
                    disabledHours: () => [...Array(now.hour()).keys()],
                    disabledMinutes: () => [],
                };
            }
        }
        return {
            disabledHours: () => [],
            disabledMinutes: () => [],
        };
    };



    return (
        <>
            <Alert style={
                {
                    width: '100% + 48px',
                    margin: '-24px -24px 20px',
                    border: 'none',
            }} showIcon={true} message="温馨提示：如需收费请联系用户在APP内发起续租" type="info" />
            <Form.Item label={'订单编号'}>
                {data.order_code}
            </Form.Item>
            <Form.Item label={'原取还时间'}>
                {`${formatTimeRange(data?.pre_pickup_time, data?.pre_return_time)}` }
            </Form.Item>

            <Form.Item  name={'return_time'} label={'续租还车日期'} rules={[{required:true, message: '请选择续租还车日期'}]} >
                <DatePicker
                    allowClear={true}
                    showNow={false}
                    defaultPickerValue={now}
                    disabledDate={disabledDate}
                    disabledTime={disabledDateTime}
                    showTime={{
                        defaultValue: now,
                        format: 'HH:mm',
                        minuteStep: 15 , showNow: false}}
                    format="YYYY-MM-DD HH:mm"
                    placeholder="请选择续租还车日期"
                />
            </Form.Item>
        </>
    );
};

export default DriverPlatoon;
